import { Button, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { createOverviewRoute } from '../routes';

export function DataSourceNotFound({ dataSource }: { dataSource: string }) {
  const { t } = useTranslation();
  return (
    <Stack spacing={2}>
      <Typography
        variant="h1"
        align="center"
        sx={{
          marginBottom: '16px',
        }}
      >
        Unsupported DataSource {dataSource}
      </Typography>
      <Button component={Link} variant="contained" to={createOverviewRoute()}>
        {t('Terug')}
      </Button>
    </Stack>
  );
}
